import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';

import type { TradingPhotoCardType } from '../../trading/types/TradingPhotoCardType';
import { QUERY_KEYS } from '../../trading/constants/QueryKeys';

interface TradingPhotoCardsResponse {
  tradingPhotoCards: TradingPhotoCardType[];
}

interface UseAllTradingPhotoCardsQueryProps {
  category: 'sale' | 'exchange';
}

export function useAllTradingPhotoCardsQuery({ category }: UseAllTradingPhotoCardsQueryProps) {
  const tradingPhotoCardsQueryParams = new URLSearchParams({
    page: '1',
    per_page: '10000'
  });

  if (category) {
    tradingPhotoCardsQueryParams.append('category', category);
  }

  const { data, isLoading, error } = useQuery<TradingPhotoCardsResponse>(
    QUERY_KEYS.tradingPhotoCardsAll(category),
    () => queryGet(`/api/v1/trading_photo_cards?${tradingPhotoCardsQueryParams.toString()}`)
  );

  return {
    tradingPhotoCards: data?.tradingPhotoCards || [],
    isLoading,
    error
  };
}
